import { LoadingOutlined, WarningOutlined } from "@ant-design/icons"
import { Button, Col, Row, Spin } from "antd"
import React from "react"

export const ErrorActions = (props: { handleRestart, loading, setForced, handlePause }) => (
  <div className='error-action-div'>
    <Spin indicator={<LoadingOutlined className='loading-icon' />} spinning={props.loading}>
      <Button className='restart-control' onClick={props.handleRestart}>Relancer scan</Button>
      <Button className='pause-control' onClick={props.handlePause}>Mettre en pause</Button>
      {sessionStorage.getItem('error') &&
        <Button onClick={() => { props.setForced(true) }} className='force-control' >Valider</Button>}
    </Spin>
  </div>
)

export const TrayError = (props: { bracelets: any, wrongCount, handleRestart, loading, setForced, handlePause }) => (
  <div>
    {props.wrongCount ?
      <>
        <h4 className='tray-error'><WarningOutlined className='error-icon' /> Erreur de comptage</h4>
        <span>{props.wrongCount}</span>
      </>
      :
      <>
        <h4 className='tray-error'><WarningOutlined className='error-icon' /> {props?.bracelets?.length} {props?.bracelets?.length > 1 ? "Erreurs" : "Erreur"}</h4>
        <div className='scrolling-div-error'>
          {props.bracelets && props.bracelets.map((elem, index) => (
            <Row key={index} style={{ paddingBottom: '1rem' }}>
              <Col xs={4} style={{ display: "flex", alignContent: 'center', alignItems: 'center' }}>
                <div className='error-badge'>
                  <span className='error-span'>{elem.count}</span>
                </div>
              </Col>
              <Col xs={20}>
                <div className='tray-sku'>SKU {elem.sku?.length > 0 ? elem.sku : "non reconnu"} </div>
                <div>
                  {elem.count} {(elem.count > 1 ? "bracelets" : "bracelet") + " ne correspondent pas au SKU attendu"}
                </div>
              </Col>
            </Row>
          ))}
        </div>
      </>
    }
    <ErrorActions handlePause={props.handlePause} handleRestart={props.handleRestart} loading={props.loading} setForced={props.setForced} />
  </div>
)

export default TrayError